import { useLayoutEffect } from 'react';

/**
 * Locks the app shell's `<main>` scroll and makes it a flex column, so the
 * page fills the viewport and scrolls inside its own panes — the records
 * master-detail, the assistant's conversation. Pages reach it through
 * `<PageBody fill>`.
 *
 * `useLayoutEffect`: the cleanup runs synchronously before the next page
 * paints, so a page that returns to ordinary scrolling (the dashboard) never
 * shows a frame of the locked layout.
 */
export function useFillMainViewport(enabled: boolean): void {
  useLayoutEffect(() => {
    if (!enabled) return;
    const main = document.getElementById('main-content');
    if (!main) return;
    main.style.overflow = 'hidden';
    main.style.display = 'flex';
    main.style.flexDirection = 'column';
    return () => {
      main.style.overflow = '';
      main.style.display = '';
      main.style.flexDirection = '';
    };
  }, [enabled]);
}
